import { __assign } from "tslib";
import { Activity } from './Contracts';
import { logNotification } from './OTelNotifications';
import { cloneEvent } from './SimpleTelemetryLogger';
// Currently we only send one activity at a time
var ACTIVITY_COUNT = 1;
// Currently we do not aggregate activities in OTelJS
var ACTIVITY_AGGMODE = 0;
export var getCurrentMilliseconds = function () {
    if (typeof self === 'object' && typeof self.performance === 'object' && typeof self.performance.now === 'function') {
        getCurrentMilliseconds = function () {
            return self.performance.now();
        };
    }
    else {
        getCurrentMilliseconds = function () {
            return Date.now();
        };
    }
    return getCurrentMilliseconds();
};
export var createActivity = function (activityProperties) {
    var _startTime = getCurrentMilliseconds();
    var _ended;
    var clonedEvent = cloneEvent(activityProperties.telemetryEvent);
    return __assign(__assign({ cv: activityProperties.parentCv.getNext() }, clonedEvent), { 
        /**
         * Creates an activity parented to this one.
         * @param telemetryEvent - The underlying telemetry event for this activity
         */
        createChildActivity: function (telemetryEvent) {
            return createActivity({
                telemetryEvent: telemetryEvent,
                sendTelemetryEvent: activityProperties.sendTelemetryEvent,
                parentCv: this.cv
            });
        }, 
        /**
         * Sets the result of the activity. Does not end it.
         * @param resultCode - The result code, e.g. 0 for success
         * @param resultType - Optional: The result type, e.g. "HRESULT"
         * @param resultTag - Optional: The result tag
         */
        setResult: function (code, type, tag) {
            this.result = { code: code, type: type, tag: tag };
        }, 
        /**
         * Ends the activity; records the duration and sends a telemetry event.
         */
        endNow: function () {
            var _this = this;
            var _a, _b;
            if (_ended) {
                logNotification(0 /* LogLevel.Error */, 0 /* Category.Core */, function () { return "'".concat(_this.eventName, "' already ended"); });
                return;
            }
            if (this.success === undefined && this.result === undefined) {
                // The Activity dashboard shows these activities as 'unresolved'
                // but developers generally should avoid leaving activities in this state.
                logNotification(1 /* LogLevel.Warning */, 0 /* Category.Core */, function () { return 'Activity does not have success or result set'; });
            }
            var endTime = getCurrentMilliseconds();
            var durationInMicroseconds = Math.floor((endTime - _startTime) * 1000);
            _ended = true;
            // Fill the event contract
            var activity = {
                duration: durationInMicroseconds,
                count: ACTIVITY_COUNT,
                aggMode: ACTIVITY_AGGMODE,
                cV: this.cv.value,
                success: this.success,
                result: this.result
            };
            var newDataFields = (_b = (_a = this.eventContract) === null || _a === void 0 ? void 0 : _a.dataFields) !== null && _b !== void 0 ? _b : [];
            newDataFields.push.apply(newDataFields, Activity.getFields(activity));
            this.eventContract = {
                name: Activity.contractName,
                dataFields: newDataFields
            };
            return activityProperties.sendTelemetryEvent(this);
        } });
};
//# sourceMappingURL=Activity.js.map